import { Eye, Lock } from "lucide-react"
import { Badge } from "@/components/ui/badge"
import type { BidArtifact } from "@/lib/api"

export function ArtifactStatusBadge({ status }: { status: BidArtifact['status'] | undefined }) {
  if (!status || status === 'draft' || status === 'in_progress') return null
  if (status === 'pending_review') {
    return (
      <Badge variant="review" dot={false} className="text-xs">
        <Eye className="h-3 w-3" />
        In review
      </Badge>
    )
  }
  if (status === 'changes_requested') {
    return (
      <Badge variant="warning" className="text-xs">
        Changes requested
      </Badge>
    )
  }
  if (status === 'finalized') {
    return (
      <Badge variant="success" dot={false} className="text-xs">
        <Lock className="h-3 w-3" />
        Finalised
      </Badge>
    )
  }
  return null
}
